<template>
  <div>
    <beast-header/>
    <div class="container">
      <beast-search-box v-on:searchEnded="updateSearch"/>
      <beast-packages-list v-on:keywordSearch="updateSearch"/>
    </div>
    <beast-footer/>
  </div>
</template>

<script>
import BeastHeader from "../components/header/BeastHeader.vue";
import BeastFooter from "../components/footer/BeastFooter.vue";
import BeastSearchBox from "../components/packages/BeastSearchBox.vue";
import BeastPackagesList from "../components/packages/BeastPackagesList.vue";

export default {
  components: {
    BeastPackagesList, BeastSearchBox, BeastFooter, BeastHeader
  },
  methods: {
    updateSearch(query) {
      this.$router.replace({
        name: "search",
        query: {
          query,
          page: 1
        }
      });
    }
  },
  mounted() {
    this.setTitle("Home");
  }
};
</script>
